import { render, staticRenderFns } from "./CyberboardNovel4.vue?vue&type=template&id=feb47f02&scoped=true"
import script from "./CyberboardNovel4.vue?vue&type=script&lang=ts"
export * from "./CyberboardNovel4.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardNovel4.vue?vue&type=style&index=0&id=feb47f02&prod&lang=scss&scoped=true"
import style1 from "./CyberboardNovel4.vue?vue&type=style&index=1&id=feb47f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb47f02",
  null
  
)

export default component.exports